/**
 * `environments_list` — variable NAMES, `secret`, `isEmpty`, and which scope
 * each name is defined in. **No value, at any depth, ever (O7).**
 *
 * The projection has no value field, which is the only reason this is safe:
 * there is no branch to forget. `mcpRequestProjection.test.js` walks the whole
 * result for the KEY NAME `value` as well as for the planted secrets
 * themselves, because a single spread of a variable row would put every token
 * in the user's environments into a model's context in one line.
 *
 * This tool exists because `request_read` hands back
 * `Authorization: Bearer {{apiToken}}` and that answer is only half an answer.
 * "The header is wired to `apiToken`, and `apiToken` is defined in the `dev`
 * environment but EMPTY" is the other half, and it is the whole of what the
 * owner asked for when they asked why a request returns an error.
 */
import { currentWorkspaceOrRefuse, workspaceReport } from '../collectionsDb';
import { environmentsReport } from '../variableScopes';

export async function environmentsList() {
  const gate = currentWorkspaceOrRefuse();
  if (gate.error) return gate.error;
  const { workspace } = gate;

  const report = environmentsReport();
  return {
    workspace: workspaceReport(workspace),
    selectedEnvironmentId: report.selectedEnvironmentId,
    environments: report.environments,
    workspaceVariables: report.workspaceVariables,
    globalVariables: report.globalVariables,
    // Said in the result as well as in the tool description, because a model
    // that assumes an omitted value means an empty one will give the user
    // confidently wrong advice.
    note: 'Variable VALUES are never returned by this server, in any tool. `isEmpty` is the only thing said about a value.',
    scopesConsulted: [],
    scopesUnavailable: [],
  };
}
